export const words = {
  place: "Местонахождение",
  yes: "Да",
  no: "Нет",
  new: "Новый",
  agb: 'AGB',
  agb_full: "Общие положения и условия",
  datenschutzerklaerung: "Политика конфиденциальности",
  status: "Статус",
  company_name: "Название компании",
  next_button: "Далее",
  device_name: "Имя устройства",
  to_connect: "Подключайтесь",
  pin: 'PIN',
  time: "Время",
  first_name: "Имя",
  last_name: "Фамилия",
  code: "Код",
  help: "Помощь",
  total_time: "Общее время",
  latitude: "Широта",
  longitude: "Долгота",
  accuracy: "Точность",
  timestamp: "Временная метка",
  device_id: "Идентификатор устройства",
  active: "активный",
  o_clock: "Часы",
  loading: "Магазин",
  annotation: "Примечание",
  since: "с",
  camera: "Камера",
  map: "Карта",
  gallery: "Галерея",
  work: "Работа",
  employees: "Сотрудники",
  login: "Регистрация",
  login_action: "Войти",
  calendar_week_abbreviation: 'KW',
  calendar: "Календарь",
  to_call: "Звоните на",
  email: "Электронная почта",
  attachment: "Приложение",
  operational_planning: "Оперативный план",
  to_scan: "Сканировать",
  download: "Скачать",
  export: "Экспорт",
  to_document: "Документ",
  checklist: "Контрольный список",
  checklists: "Контрольные списки",
  password: "Пароль",
  confirmation: "Подтверждение",
  confirm: "Подтвердите",
  confirmation_email: "Подтверждающее письмо",
  unknown: "Неизвестный",
  unknown_place: "Местоположение неизвестно",
  unknown_plan: "Безымянное расписание смены",
  project_no: "Проект №.",
  project_file: "Файл проекта",
  contact_person: "Связаться с",
  overtime: "Сверхурочная работа",
  timesheet: "Расписание",
  minustime: "Минусы часов",
  back: "Назад",
  undo: "Отменить",
  clockout: "Штамповать",
  clocked_out: "с печатью",
  clockin: "Штамп в",
  clocked_in: "с печатью",
  dismiss: "Отмена",
  discard: "Отвергать",
  finish: "Готовый",
  or: "или",
  copy: "Копировать",
  qr_code: "QR-код",
  documentation: "Учет рабочего времени и документация",
  attendance: "Планшетный терминал",
  tiercontent: "Объем пакета",
  start_now: "Начните прямо сейчас",
  skip: "пропустить",
  logout_during_core_time: "Запечатано в основное время",
  absent_during_core_time: "Отсутствует в течение основного времени",
  distance: "Расстояние",
  km_reading: "Пробег",
  the_start: "Начало",
  the_end: "Конец",
  license_plate: "Номерной знак",
  details: "подробности",
  hide: "скрыть",
  cost: "Затраты",
  file: "Файл",
  address_book: "Адресная книга",
  template_plural: "Шаблоны",
  signature: "Подпись",
  main_project: "Основной проект",
  main_projects: "Основные проекты",
  sub_projects: "Субпроекты",
  scan_to_login_header: "Регистрация QR-кода",
  description: "Описание",
  project_location: "Местоположение проекта",
  phone_number: "Номер телефона",
  project_info: "Информация о проекте",
  number_short: "Нет.",
  sketch: "Эскиз",
  video: "Видео",
  delete: "Удалить",
  send: "Отправить",
  sending: "Отправить...",
  save: "Сохранить",
  granted: "одобрено",
  pending: "запрошено",
  denied: "Отклонено",
  customer: "Клиент",
  mobile_number: "Номер телефона",
  ok: "Хорошо",
  day: "День",
  tomorrow: "Утро",
  days: "Дни | День | Дни",
  holidays: "Праздники",
  vacation_days: "Праздники",
  vacation_hours: "Часы работы в отпуске",
  request: "Запрос",
  accept: "Принять",
  withdraw: "Отводить",
  hour_account: "Почасовой счет",
  period: "Период",
  to: "на",
  date: "Назначение",
  number: "Номер",
  message: "Сообщение",
  change: "изменить",
  changed: "Изменены",
  changed_fields: "Смены направления",
  type: "Искусство",
  hour: "Час",
  hours: "Часы",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Часы",
  end: "конец",
  end_date: "Крайний срок",
  start_date: "Дата начала",
  absence: "Отсутствие",
  month: "месяц",
  week: "Неделя",
  transcript: "Копия",
  time_left: "остальной",
  transcript_tasks: "Задачи",
  add_task: "Новый",
  /** Differentiation in some languages (e.g. English) */
  from: "с сайта",
  of: "с сайта",
  of_hours: "с {hours} часов",
  of_hours_abbreviation: "{hours} от часов.",
  /**************/

  used: "используется",
  update: "Обновление",
  today: "сегодня",
  correction: "Коррекция",
  work_time: "Время работы",
  break: "Перерыв",
  loading_time: "Время загрузки",
  driving_time: "Время в пути",
  business_trip: "Срок службы",
  project: "Проект",
  special_one: "Специальный1",
  special_two: "Специальный2",
  clock: "Часы",
  search: "Поиск",
  operation: "Деятельность",
  day_protocol: "Ежедневный протокол",
  continue: "больше",
  total_duration: "Общее время",
  duration: "Продолжительность",
  hello: "Здравствуйте",
  close: "закрыть",
  comment: "Комментарий",
  small: "маленький",
  medium: "средний",
  large: "большой",
  sharpie: "Pin",
  line: "Линия",
  arrow: "Стрелка",
  rectangle: "Прямоугольник",
  ellipse: "Эллипс",
  text: "Текст",
  language_settings: "Языковые настройки",
  clock_reminder: "Напоминание о штампе",
  individually: "Индивидуальный",
  from_o_clock: "с сайта",
  to_o_clock: "на",
  eraser: "Ластик",
  edit: "Редактировать",
  legal_notes: "Юридический",
  notes: "Примечания",
  note: "Примечание",
  imprint: "Оттиск",
  open_source_licenses: "Условия лицензии на открытый исходный код",
  author: "Автор",
  license_type: "Тип лицензии",
  version: "Версия",
  substitute: "Представительство",
  not_rated: "Без рейтинга",
  weekly_working_hours: "Недельное рабочее время",
  show_less: "Показать меньше",
  office_center: "Офисный центр",
  admin_view: "Управление NFC",
  register: "Регистрироваться",
  shifts: {
    shift_attachments: "Вложения (слой)",
    shift_plan_attachments: "Вложения (план смены)",
    shift_plan: "График смены",
    shift: "Слой"
  },
  absences: {
    sick: "Болезнь (продолжение выплаты заработной платы)",
    vacation: "Праздник",
    workshop: "Семинар/курс",
    special_vacation: "Специальный отпуск",
    school: "Школа",
    working_time_account: "Учет рабочего времени",
    holiday: "Праздник",
    other: "Другое",
    driving_time: "Время в пути",
    parental_leave: "Отпуск по уходу за ребенком",
    excused_absent: "Отсутствие по уважительной причине (оплачивается)",
    not_excused_absent: "Отсутствие без уважительной причины",
    sick_industrial_accident: "Болезнь Несчастный случай на производстве (ЛФЗ)",
    short_time_work: "Работа в течение короткого времени (Куг)",
    maternity_pay: "Выплаты по защите материнства/запрет на трудоустройство",
    sick_child: "Уход за больным ребенком с выплатой больничного (ежедневной) заработной платы",
    sick_child_no_payment: "Уход за больным ребенком без больничного (дневного) пособия",
    vacation_no_payment: "Неоплачиваемый отпуск",
    sick_before_short_time_work: "Пособие по болезни/болезнь до Куг",
    weather_related_failure: "Отказ из-за погодных условий",
    sick_short_time_work: "Болезнь во время Куга",
    sick_no_payment: "Болезнь (без продолжения выплаты заработной платы)",
    company_vacation: "Корпоративные праздники",
    meals_14_euro: "Небольшая надбавка за питание",
    meals_28_euro: "Большая сумма на питание"
  },
  image_editor: {
    font_size: "Размер шрифта",
    stroke_width: "Ширина линии",
    stroke_color: "Цвет линии",
    text_color: "Цвет шрифта",
    rotate_left: "Повернитесь налево",
    rotate_right: "Повернитесь направо",
    flip_horizontal: "Зеркало в горизонтальном положении",
    flip_vertical: "Зеркало в вертикальном положении"
  },
  travel_log: {
    method_of_transportation: "Средства передвижения",
    company_car: "Автомобиль компании",
    private_car: "Личный автомобиль",
    rental_car: "Аренда автомобиля",
    taxi: "Такси",
    public_transportation: "Общественный транспорт",
    airplane: "Аэроплан",
    train: "Железнодорожный транспорт (общественный транспорт дальнего следования)",
    other: "Другие",
    km_reading_start: "Начало пробега",
    km_reading_end: "Конец пробега",
    net_expenses: "Командировочные расходы (нетто)",
    tax: "Налог на добавленную стоимость"
  },
  read_in: "Читать в",
  currency: "Валюта",
  reason: "Причина",
  label: "Ярлык",
  monday: "Понедельник",
  tuesday: "Вторник",
  wednesday: "Среда",
  thursday: "Четверг",
  friday: "Пятница",
  saturday: "Суббота",
  sunday: "Воскресенье",
  break_alarm: "Сломайте будильник",
  clockin_reminder: "Напоминание о прибытии",
  clockout_reminder: "Напоминание отписаться"
};